module.exports = __webpack_public_path__ + "img/etisalat-logo-new.a8aaaff6.png";